import { render, staticRenderFns } from "./PromotionCard.vue?vue&type=template&id=7f94cf24&scoped=true"
import script from "./PromotionCard.vue?vue&type=script&lang=js"
export * from "./PromotionCard.vue?vue&type=script&lang=js"
import style0 from "./PromotionCard.vue?vue&type=style&index=0&id=7f94cf24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f94cf24",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
